<template>
    <!-- /.login-box-body -->
    <div id="ChangeTermos" class="modal fade in" data-backdrop="static" data-keyboard="false" role="dialog">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <!-- Modal content-->
                <div class="modal-header py-2">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body px-5 text-justify">
                    <h4 class="modal-title text-center">
                        <!-- <i class="fa fa-file-text-o"></i>  -->
                        <span class="text-uppercase">TERMO DE LICENÇA PARA OPERAÇÃO COM O PROGRAMA DE COMPUTADOR
                            {{appShortName}}</span>
                    </h4>
                    <p>
                        Por meio deste TERMO, que entre si fazem um acordo legal, de um lado, MBD Informática Ltda,
                        situada à Avenida Peixoto de Castro, 1099, Lorena/SP, CEP 12606-580, inscrita no CNPJ sob n.
                        03.386.358/0001-92 e I.E. sob n. 420.126.021.113, doravante denominado LICENCIANTE, de outro
                        lado à pessoa física ou jurídica qualificada, denominado LICENCIADO, a qual é parte integrante e
                        indivisível deste documento, doravante denominada como LICENCIADO, estabelecem de comum acordo e
                        dando o aceite eletrônico no Portal DocX neste TERMO pactuar os seguintes Itens:
                    </p>
                    <p><strong> 1 - OBJETIVO:</strong></p>
                    <p>
                        a) O LICENCIADO irá utilizar por meio do acesso ao portal DocX (Website -
                        www.docxdigital.com.br) e
                        após cadastro prévio o programa de computador chamado DocX conforme disponibilizado pelo
                        LICENCIANTE, onde este programa DocX de computador pode incluir meios físicos, manuais online e
                        material de marketing eletrônico.
                    </p>
                    <p><strong> 2 - VALORES E CONDIÇÕES DE PAGAMENTO: </strong></p>
                    <p>
                        a) O LICENCIADO pagará ao LICENCIANTE o valor do Plano de licenciamento conforme a opção
                        escolhida na página de Planos do Portal DocX, sendo facultado a devolução de valores após
                        concordado eletronicamente com este TERMO, podendo gerar créditos para compras posteriores
                        mediante a análise do LICENCIANTE após solicitação escrita do LICENCIADO. </p>
                    <p> b) O LICENCIADO fica sujeito no caso de atraso do pagamento da licença e de outros serviços
                        executados à multa, além dos juros de mora e suspensão do acesso ao Portal DocX, da utilização
                        do(s) serviço(s) e do direito de uso do objetivo deste contrato. </p>
                    <p> c) O reajuste anual da LICENÇA fica estabelecida no mes de janeiro sendo de acordo com o índice
                        acumulado dos últimos 12 meses do IPCA/IBGE, bem como os outros serviços que venham a ter
                        cobrança para execução. Este índice poderá ser alterado caso haja mudanças provenientes da
                        legislação em vigor e/ou a adição de novos custos para manutenção dos serviços, não obrigando a
                        LICENCIANTE a informar tal mudança previamente. </p>
                    <p><strong> 3 - DA RESPONSABILIDADE DA LICENCIANTE: </strong></p>
                    <p>
                        a) Ceder o direito de uso do DocX ao LICENCIADO, mediante ao pagamento prévio da licença
                        referida no Subitem A do Item 2; </p>
                    <p>
                        b) Fornecer atendimento para suporte técnico através de contato
                        telefônico, programa de mensagem instantânea WhatsApp, Bate Papo no Portal DocX e acesso remoto
                        previamente autorizado pelo LICENCIADO, que visem orientar a utilização e o manuseio do programa
                        de computador DocX, em dias uteis e horários comerciais, podendo ser previa e exclusivamente
                        agendados; </p>
                    <p>
                        c) Prestar o(s) serviço(s) constante(s) do Subitem anterior fora dos dias uteis e do
                        horário comercial mediante a prévia solicitação do LICENCIADO tendo ciência da cobrança de taxa
                        extra pelas horas de atendimento. </p>
                    <p>
                        d) Fornecer atualizações do programa de computador DocX para o
                        LICENCIADO conforme alterações na legislação vigente e/ou modernização de recursos definidos
                        pelo LICENCIANTE, desde que cumpridas as obrigações descritas no Item 4 e não estando enquadrado
                        no Subitem B do Item 2; </p>
                    <p>
                        e) Devido à natureza do programa de computador DocX e as
                        particularidades envolvidas em todo processo de criação e operação, a garantia se dará pelo
                        LICENCIANTE através do compromisso de correção na versão posterior de problemas que comprometam
                        a interrupção de funcionamento e/ou a não conformidade na operação, mas para isto é necessário
                        que o LICENCIADO informe ao LICENCIANTE através do Subitem B contida no Item 4.</p>
                    <p><strong> 4 - DA RESPONSABILIDADE DO LICENCIADO: </strong></p>
                    <p>
                        a) Os dados armazenados no programa de computador DocX são pertencentes ao LICENCIADO e de sua
                        responsabilidade a inclusão, manutenção, segurança e integridade desses dados, entretanto o
                        LICENCIADO dá autorização para a coleta, armazenamento, acesso, uso e proteção de dados ao
                        LICENCIANTE com o objetivo da correta execução operacional do programa de computador DocX. </p>
                    <p> b) As manutenções solicitadas no programa de computador DocX deverão ser encaminhadas através do
                        endereço eletrônico suporte@mbd.com.br a LICENCIANTE, sendo analisadas e se aprovadas serão
                        executas conforme Subitem E contida no Item 3, as solicitações não aprovadas por serem
                        decorrentes de mudanças que não tem funcionalidade geral do programa de computador podem ser
                        consideradas personalização para o LICENCIADO, gerando um orçamento para aprovação, ou podem ser
                        descartadas, sem obrigação de comunicação por parte do LICENCIANTE. </p>
                    <p> c) Fica ainda definido que qualquer taxa e/ou despesas de deslocamento, como pedágio, hospedagem
                        e alimentação, quando necessários e aprovador por ambas as partes, devem ser de responsabilidade
                        do LICENCIADO e serão pagos no final do atendimento. </p>
                    <p> d) As chamadas de suporte deverão ser feitas pelo telefone (12) 3152-9360, mensagem eletrônica
                        para suporte@mbd.com.br, mensagem instantânea (WhatsApp) +55-12-97404-9319, mensagem pelo Portal
                        DocX ou diretamente no endereço da LICENCIANTE, desde que agendado e em horário comercial e dias
                        úteis. Para chamadas de emergência fora do horário comercial deverá ser feito através do
                        telefone celular (12) 97404-9319. </p>
                    <p><strong>
                            5 - DA VIGÊNCIA DO CONTRATO:
                        </strong></p>
                    <p>
                        a) O presente contrato é celebrado pelo prazo de 12 meses a partir do aceite do mesmo no Portal
                        DocX, podendo ser renovado automaticamente sem a necessidade de comunicado prévio, onde o
                        LICENCIADO executará novamente o pagamento conforme Subitem A do Item 2. </p>
                    <p> b) Este contrato passa a ter fidelidade de 12 meses após pagamento e aceite eletrônico no Portal
                        DocX, onde a rescisão implicará no pagamento imediato e total dos meses restantes do período de
                        fidelidade. </p>
                    <p> c) Para a rescisão deste TERMO, ambas as partes se comprometem em solicitar o cancelamento com
                        30 dias de antecedência, caso contrário cabe à parte que ocasionar o rompimento do presente
                        contrato, o pagamento de multa rescisória fixada em um salário mínimo à outra parte.
                    </p>
                    <p><strong> 6 – DAS DISPOSIÇÔES GERAIS: </strong></p>
                    <p>
                        a) O presente contrato obriga as partes e seus sucessores, a qualquer titulo, não podendo ser
                        cedido ou transferido sem prévia e escrita aprovação da outra parte. Qualquer tentativa de
                        cessão ou transferência sem tal aprovação constituirá infração contratual e legal. </p>
                    <p> b) Somente o LICENCIANTE está autorizada autorizar o uso e a prestar serviços no programa de
                        computador DocX, sendo certo que, todo conteúdo do Portal DocX, a sua documentação e
                        características não poderão ser copiadas e reproduzidas ainda que parcialmente, sob pena de se
                        sujeitar às penalidades criminais ditadas pela Lei 9.609/98, sem prejuízo da perda imediata da
                        presente cessão onerosa e provisória de direitos, além do pagamento à LICENCIANTE, da multa
                        correspondente 10 (dez) vezes o maior valor do Plano que consta no Portal DocX. Este TERMO não
                        dá o direito ao LICENCIADO de aquisição do programa de computador DocX, direito à propriedade
                        intelectual, direito autoral, informações confidenciais, segredos estratégicos do negócio ou
                        qualquer conteúdo disponibilizado no Portal DocX. </p>
                    <p> c) Fica ressalvado que não haverá vinculo trabalhista entre as partes, estando ambas livres de
                        quaisquer ônus e obrigações dessa natureza, ou de ordem previdenciária, seja uma para com a
                        outra, ou para com seus respectivos empregados, bem como de arcar com indenizações por acidentes
                        eventualmente sofridos por seus empregados. </p>
                    <p> d) Este contrato reflete o integral entendimento entre as partes, prevalecendo sobre quaisquer
                        contratos e correspondências anteriores firmadas entre as mesmas, que o aceite eletrônico, uso
                        constante da licença através do acesso ao Portal DocX e o pagamento do Plano realizados no
                        Portal DocX, substitui a obrigação de assinaturas neste TERMO. Em caso de discordância deste
                        TERMO o uso deve ser imediatamente suspenso e comunicado ao LICENCIANTE através de mensagem
                        eletrônica do endereço mbd@mbd.com.br. </p>
                    <p> e) Caso seja comprovada a falta de pagamento definida no Subitem A do Item 2 ou Subitem A do
                        Item 5 após o 5o dia do vencimento, independente do motivo exposto sem a consentimento da
                        LICENCIANTE, as responsabilidades descritas nos Item 3 serão suspensas até o devido pagamento,
                        incluído os juros e multa, se houverem. </p>
                    <p> f) O presente Contrato não abrange mão de obra para manutenção de equipamentos, despesas com
                        peças de reposição ou substituição e material utilizado na execução da operação ou do
                        atendimento, que correrão por conta do LICENCIADO, bem como investimento técnico na segurança
                        física dos computadores e dos dados utilizados para as operações do programa de computador DocX.
                    </p>
                    <p> g) Obrigam-se as partes a manterem o mais absoluto sigilo das informações e dados que vierem a
                        serem fornecidos entre si, respeitando integralmente a Lei Geral de Proteção de Dados (LGPD –
                        13.709/2018), onde a comprovada quebra do sigilo por uma das partes implicará no pagamento, por
                        parte daquela que der causa, de multa no valor de 5 (cinco) vezes o maior valor do Plano no
                        Portal DocX em até 48h da comunicação por escrito da parte prejudicada, independente de
                        possíveis ações de reparação a serem impetradas na Justiça. </p>
                    <p class="pb-3"> h) O presente contrato garante a validação conforme demonstrações, esclarecimentos
                        e avaliações
                        realizadas no período de degustação, ficando de acordo e validado os recursos do programa de
                        computador DocX para aquisição e utilização pela LICENCIADA. E por estarem assim pactuadas,
                        firmam as partes o presente contrato, assinado pelas partes e por duas testemunhas, em 02 (duas)
                        vias de igual teor e único efeito.
                    </p>
                    <p class="text-right">Lorena/SP, abril de 2021</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>

<style scoped src="@/assets/sass/bootstrap4.css"></style>
<style scoped>
    h4 span {
        font-weight: 600;
        text-decoration: underline;
    }

    p {
        margin: 0;
    }

    .modal-body {
        max-height: calc(100vh - 120px)
    }
</style>